<!-- eslint-disable vuejs-accessibility/anchor-has-content -->
<!-- eslint-disable vuejs-accessibility/heading-has-content -->
<template>
  <div class="uberall-locator-info-box__hidden-container">
    <div
      id="uberall-locator-info-box"
      class="uberall-locator-info-box"
    >
      <div class="uberall-locator-info-box__title-wrapper">
        <h3 class="uberall-locator-info-box__title text-body-2xs-regular" />

        <div
          v-if="isMobile"
          class="uberall-locator-info-box__open-hours mobile"
        >
          <div class="uberall-locator-info-box__is-open" />
          <p class="uberall-locator-info-box__hours-label text-body-2xs-regular" />
        </div>
      </div>

      <p class="uberall-locator-info-box__street text-body-2xs-regular" />
      <p class="uberall-locator-info-box__address text-body-2xs-regular" />
      <a class="uberall-locator-info-box__pn text-body-2xs-underline" />
      <p class="uberall-locator-info-box__distance text-body-2xs-regular" />

      <div
        v-if="!isMobile"
        class="uberall-locator-info-box__open-hours desktop"
      >
        <div class="uberall-locator-info-box__is-open" />
        <p class="uberall-locator-info-box__hours-label text-body-2xs-regular" />
      </div>

      <div class="uberall-locator-info-box__buttons-wrapper">
        <btn
          class="uberall-locator-info-box__get-directions"
          :label="$string('store_locator.get_directions')"
          modifiers="primary center"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * HTML model for Google Map Info Box
 *
 * Is stored on the page, until Google Maps is loaded and uses the snippet
 */

import { mapState } from 'vuex'
import Btn from '~global/btn/btn'

export default {
  name: 'UberallLocatorInfoBox',

  components: {
    Btn,
  },

  data() {
    return {}
  },

  computed: {

    /**
     * Map Vuex state
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  methods: {},
}
</script>
